export const getUserInviteFeedback = (result, resent = false) => {
  if (result.email_sent === false) {
    return {
      message: resent
        ? "Invite token refreshed, but the email could not be sent."
        : `User created, but the invitation email to ${result.email} could not be sent.`,
      type: "warning",
    };
  }

  return {
    message: resent ? "Invite resent successfully." : `Invite sent to ${result.email}`,
    type: "success",
  };
};